module.exports = __webpack_public_path__ + "media/assets/svg/logos/leanbit_logo_with_symbol-c13c9228de734c3d01bf97017edc35f1.svg";